<template>
  <div class="line-divider">
    <div :class="`line-divider__line line-divider__line--${spacing} line-divider__line--${color}`" />
  </div>
</template>

<script>
export default {
  name: "LineDivider",
  props: {
    spacing: {
      type: String,
      required: false,
      default: "m"
    },
    color: {
      type: String,
      require: false,
      default: "light-grey"
    }
  }
}
</script>

<style lang="scss" scoped>
.line-divider {
  width: 100%;

  &__line {
    height: 1px;

    &--light-grey {
      background: $light-grey;
    }

    &--lightest-grey {
      background: $lightest-grey;
    }

    &--m {
      margin-bottom: $spacing-24;
    }

    &--l {
      margin-bottom: $spacing-48;
    }
  }
}
</style>
